// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemoRightColumn-module__main--mWczH {
    position: absolute;
    right: 0;
    width: var(--grid-width-4);
    padding-left: 80px;
    max-height: calc(100vh - var(--app-offset-top) - var(--app-offset-bottom));
    display: flex;
    pointer-events: none;
    flex-direction: column;
}

.DemoRightColumn-module__main--mWczH > * {
    pointer-events: auto;
}

@media (max-width: 1440px) {
    .DemoRightColumn-module__main--mWczH {
        padding-left: 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/DemoRightColumn.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,0BAA0B;IAC1B,kBAAkB;IAClB,0EAA0E;IAC1E,aAAa;IACb,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".main {\n    position: absolute;\n    right: 0;\n    width: var(--grid-width-4);\n    padding-left: 80px;\n    max-height: calc(100vh - var(--app-offset-top) - var(--app-offset-bottom));\n    display: flex;\n    pointer-events: none;\n    flex-direction: column;\n}\n\n.main > * {\n    pointer-events: auto;\n}\n\n@media (max-width: 1440px) {\n    .main {\n        padding-left: 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `DemoRightColumn-module__main--mWczH`
};
export default ___CSS_LOADER_EXPORT___;
